"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.educationLevelOptions = exports.educationLevelLabels = exports.educationLevel = exports.titleTypeOptions = exports.titleTypeLabels = exports.titleType = exports.workPermitTypeOptions = exports.workPermitType = exports.documentTypeOptions = exports.documentTypeValues = exports.booleanCheckOptions = exports.booleanCheckLabels = exports.booleanCheckValues = exports.sexTypeOptions = exports.sexType = exports.maritalStatusOptions = exports.maritalStatus = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _forms = require("../../helpers/forms");

var _booleanCheckLabels, _titleTypeLabels, _educationLevelLabels;

var maritalStatus = {
  MARRIED: 'married',
  SINGLE: 'single',
  DIVORCED: 'divorced',
  WINDOWED: 'widowed',
  SEPARATED: 'separated',
  COHABITING: 'cohabiting',
  CIVILPARTNERSHIP: 'civil_partnership'
};
exports.maritalStatus = maritalStatus;
var maritalStatusOptions = [{
  value: maritalStatus.MARRIED,
  label: 'Married'
}, {
  value: maritalStatus.SINGLE,
  label: 'Single'
}, {
  value: maritalStatus.DIVORCED,
  label: 'Divorced'
}, {
  value: maritalStatus.WINDOWED,
  label: 'Widowed'
}, {
  value: maritalStatus.SEPARATED,
  label: 'Separated'
}, {
  value: maritalStatus.COHABITING,
  label: 'Co-habiting'
}, {
  value: maritalStatus.CIVILPARTNERSHIP,
  label: 'Civil Partnership'
}];
exports.maritalStatusOptions = maritalStatusOptions;
var sexType = {
  MALE: 'male',
  FEMALE: 'female'
};
exports.sexType = sexType;
var sexTypeOptions = [{
  value: sexType.MALE,
  label: 'Male'
}, {
  value: sexType.FEMALE,
  label: 'Female'
}];
exports.sexTypeOptions = sexTypeOptions;
var booleanCheckValues = {
  YES: 'yes',
  NO: 'no'
};
exports.booleanCheckValues = booleanCheckValues;
var booleanCheckLabels = (_booleanCheckLabels = {}, (0, _defineProperty2["default"])(_booleanCheckLabels, booleanCheckValues.YES, 'Yes'), (0, _defineProperty2["default"])(_booleanCheckLabels, booleanCheckValues.NO, 'No'), _booleanCheckLabels);
exports.booleanCheckLabels = booleanCheckLabels;
var booleanCheckOptions = (0, _forms.generateSelectOptions)(booleanCheckLabels);
exports.booleanCheckOptions = booleanCheckOptions;
var documentTypeValues = {
  ID: 'id',
  PASSPORT: 'passport'
};
exports.documentTypeValues = documentTypeValues;
var documentTypeOptions = [{
  value: documentTypeValues.ID,
  label: 'ID'
}, {
  value: documentTypeValues.PASSPORT,
  label: 'Passport'
}];
exports.documentTypeOptions = documentTypeOptions;
var workPermitType = {
  L: 'L',
  G: 'G',
  C: 'C',
  B: 'B'
};
exports.workPermitType = workPermitType;
var workPermitTypeOptions = (0, _forms.generateSelectOptions)(workPermitType);
exports.workPermitTypeOptions = workPermitTypeOptions;
var titleType = {
  MR: 'mr',
  MRS: 'mrs',
  MISS: 'miss',
  MS: 'ms'
};
exports.titleType = titleType;
var titleTypeLabels = (_titleTypeLabels = {}, (0, _defineProperty2["default"])(_titleTypeLabels, titleType.MR, 'Mr'), (0, _defineProperty2["default"])(_titleTypeLabels, titleType.MRS, 'Mrs'), (0, _defineProperty2["default"])(_titleTypeLabels, titleType.MISS, 'Miss'), (0, _defineProperty2["default"])(_titleTypeLabels, titleType.MS, 'Ms'), _titleTypeLabels);
exports.titleTypeLabels = titleTypeLabels;
var titleTypeOptions = (0, _forms.generateSelectOptions)(titleTypeLabels);
exports.titleTypeOptions = titleTypeOptions;
var educationLevel = {
  HIGH_SCHOOL: 'high_school',
  BACHELOR: 'bachelor',
  MASTER: 'master',
  DOCTORATE_POSTDOCTORATE: 'doctorate_postdoctorate'
};
exports.educationLevel = educationLevel;
var educationLevelLabels = (_educationLevelLabels = {}, (0, _defineProperty2["default"])(_educationLevelLabels, educationLevel.HIGH_SCHOOL, 'High School/equivalent'), (0, _defineProperty2["default"])(_educationLevelLabels, educationLevel.BACHELOR, "Bachelor's Degree"), (0, _defineProperty2["default"])(_educationLevelLabels, educationLevel.MASTER, "Master's Degree"), (0, _defineProperty2["default"])(_educationLevelLabels, educationLevel.DOCTORATE_POSTDOCTORATE, 'Doctorate or Post-doctorate'), _educationLevelLabels);
exports.educationLevelLabels = educationLevelLabels;
var educationLevelOptions = (0, _forms.generateSelectOptions)(educationLevelLabels);
exports.educationLevelOptions = educationLevelOptions;